export default __webpack_public_path__ + "static/media/Girdle of the Ichorous.3e1ca7a0.jpg";